<template>
    <div>
        <loading
            :active.sync="loading.app"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link
                    :to="{ name: back_reference }"
                    class="headerButton"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">PIN Keamanan</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <!-- Pilih Metode Pengiriman Kode Verifikasi -->
            <div v-if="step == 1">
                <div class="section m-2 p-2">
                    <div class="text-center">
                        <h4>Buat Kode PIN</h4>
                        <small style="line-height: normal"
                            >Untuk keamanan akun dan transaksi, buat Kode PIN
                            Keamanan</small
                        >
                    </div>
                </div>
                <div class="section mb-5 p-2">
                    <div class="pin-container">
                        <input
                            type="number"
                            name="pin-code"
                            class="pin-input"
                            pattern="\d*"
                            maxlength="6"
                            inputMode="numeric"
                            autocomplete="off"
                            v-model="auth_data.pin"
                            @input="next_step()"
                        />
                    </div>
                </div>
            </div>
            <div v-else-if="step == 2">
                <div class="section m-2 p-2">
                    <div class="text-center">
                        <h4>Konfirmasi Kode PIN Baru</h4>
                        <small style="line-height: normal"
                            >Sekali lagi, masukkan kembali Kode PIN Keamanan
                            yang baru Kamu buat</small
                        >
                    </div>
                </div>
                <div class="section mb-5 p-2">
                    <div class="pin-container">
                        <input
                            type="number"
                            name="pin-code"
                            class="pin-input"
                            pattern="\d*"
                            maxlength="6"
                            inputMode="numeric"
                            autocomplete="off"
                            v-model="auth_data.pin_confirmation"
                            @input="submitVerifyRegister()"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState, mapActions } from 'vuex';
    export default {
        name: 'auth.register.pin',
        props: ['back_reference'],
        data() {
            return {
                step: 1,
            };
        },
        created() {
            setTimeout(
                () => this.$store.commit('SET_LOADING', { app: false }),
                500
            );
        },
        computed: {
            ...mapState(['loading', 'toast']),
            ...mapState('auth', {
                auth_data: state => state.auth_data,
            }),
        },
        methods: {
            ...mapActions('auth', ['verifyRegister', 'login']),
            next_step() {
                if (this.auth_data.pin.length == 6) {
                    this.$store.commit('SET_LOADING', { app: true });
                    setTimeout(() => {
                        this.$store.commit('SET_LOADING', { app: false });
                        this.step = 2;
                    }, 200);
                }
            },
            submitVerifyRegister() {
                if (this.auth_data.pin_confirmation.length == 6) {
                    this.$store.commit('SET_LOADING', { app: true });
                    setTimeout(() => {
                        if (
                            this.auth_data.pin !==
                            this.auth_data.pin_confirmation
                        ) {
                            this.$store.commit('SET_LOADING', { app: false });
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: 'Kode PIN tidak sama',
                                tipe: 'default',
                                icon: 'danger',
                            });
                        } else {
                            // redirect to verify otp
                            this.verifyRegister()
                                .then(() => {
                                    // // window.fbq("track", "CompleteRegistration");

                                    this.$router.push({
                                        name: 'auth.otp.verify',
                                        params: {
                                            data_reference: this.auth_data,
                                            url_reference:
                                                '/auth/login/verify/otp',
                                            type_reference: 'LOGIN',
                                            target_reference: 'home',
                                            back_reference: 'auth.login',
                                            phonenumber_reference:
                                                this.auth_data.phone,
                                        },
                                    });
                                })
                                .catch(error => {
                                    this.$store.commit('SET_LOADING', {
                                        app: false,
                                    });
                                    this.$store.commit('SET_TOAST', {
                                        show: true,
                                        message: error.data.message,
                                        tipe: 'default',
                                        icon: 'danger',
                                    });
                                });
                        }
                    }, 200);
                }
            },
            submit() {
                this.$store.commit('SET_LOADING', { button: true });
                this.$store.commit('SET_TOAST', { show: false });
            },
        },
        mounted() {
            if (this.back_reference == undefined) {
                this.$router.push({
                    name: 'auth.register',
                });
            }
            // console.log();
            document.body.classList.add('bg-white');
        },
        destroyed() {
            this.$store.commit('RESET_LOADING');
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
